export default __webpack_public_path__ + "static/media/expand_more_odd.cb969345.svg";